<script>
export default {
    name: 'IconSetsApp',
    data: function() {
        return {
            icons: [],
            type: null,
            types: null,
            availableTypes: [],
            iconsJSON: {}
        }
    },
    watch: {
        icons: {
            handler: function(){
                let used = [];
                for (let item of this.icons) {
                    used.push(item.name);
                }
                this.availableTypes = Object.keys(this.types[this.type]['items']).filter(x => !used.includes(x));
                this.iconsJSON = JSON.stringify(this.icons);
            },
            deep: true,
        },
        type: function(){
            this.icons = [];
            let used = [];
            for (let item of this.icons) {
                used.push(item.name);
            }
            this.availableTypes = Object.keys(this.types[this.type]['items']).filter(x => !used.includes(x));
            if (this.$root.$el.dataset.icons) {
                for (let icon of JSON.parse(this.$root.$el.dataset.icons)){
                    if (this.availableTypes.includes(icon.name)) {
                        this.icons.push(icon);
                    }
                }
            }
            this.iconsJSON = JSON.stringify(this.icons);
        }
    },
    mounted: function() {
        if (this.$root.$el.dataset.icons) {
            this.icons = JSON.parse(this.$root.$el.dataset.icons);
        }

        this.types = JSON.parse(this.$root.$el.dataset.types);
        this.type = Object.keys(this.types)[0];

        if (this.type) {
            for (let k of Object.keys(this.types[this.type]['items'])) {
                this.availableTypes.push(k);
            }
        }
    },
    methods: {
        addIcon(e) {
            let component = this;
            const type = this.availableTypes.splice(0, 1)[0];
            const file = e.target.files[0];
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                component.icons.push({name: type, src: reader.result})
            };
        },
        changeIcon(e, index) {
            let component = this;
            const file = e.target.files[0];
            const url = URL.createObjectURL(file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                component.icons.splice(index, 1, {name: component.icons[index]['name'], src: reader.result});
            };
        },
        deleteIcon(e, index) {
            this.availableTypes.push(this.icons[index]['name']);
            this.icons.splice(index, 1);
        },
    }
}
</script>
